<div>
    <div  [ngClass]="{'blue-header': displayClientSelection === true, 'blue-header-with-margin': displayClientSelection === false }">
        <!-- Client pour lequel je souhaite Intervenir -->
        {{'LOGIN_OD0005' | translate}}
    </div>

    <form>
        <div class="card-body border-external">
                <div class=" form-group" style="margin-top: 1.5rem;">
                    <span class="col-md-4">{{'LOGIN_OD0006' | translate}}</span>
                    <span class="col-md-4">
                        <select style="padding: 5px; width: 19rem;" 
                        (change)="SelectedClient($event.target.value)" >
                            <option *ngFor="let client of clientsData" [value]="client.Nom+'_'+client.Prenom">{{client.QualCiv +" "+client.Nom +" "+ client.Prenom}}</option>
                          </select>
                    </span>   
                    <!-- [value]=" client.QualCiv+' ' +client.Nom+ '' +client.Prenom"              -->
            </div>

            <div class="form-group ">
                <span class="col-md-4">{{'LOGIN_OD0008' | translate}}</span>
                <span class="col-md-4" [(ngModel)]="NumeroBCE" [ngModelOptions]="{standalone: true}" name="fieldNameNumeroBCE" ngDefaultControl>{{NumeroBCE}}</span>
            </div>

            <div class="form-group">
                <span class="col-md-4">{{'LOGIN_OD0009' | translate}}</span>
                <span class="col-md-4" [(ngModel)]="Rue + NoRue +CodePostal + Localite + LibellePays" name="fieldNameRue" ngDefaultControl>
                    {{Rue + " "+ NoRue}} <br> {{CodePostal +" "+ Localite}} <br> {{LibellePays}}
                </span>
            </div>
        </div>


        <div class="footer-class border-external">
            <button class="btn btn-orange border-external" (click)="gotoDashboard()" [disabled]="disableSubmit">
                <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                    width="24" height="24"
                    viewBox="0 0 172 172"
                    style=" fill:#000000;"><g fill="none" fill-rule="none" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="#e67e22" fill-rule="nonzero"></path><g fill="#ffffff" fill-rule="evenodd"><path d="M161.92188,25.08333l-104.14062,105.26042l-47.70312,-47.47917l-10.07812,10.30208l57.78125,57.33333l114.21875,-115.11458z"></path></g></g></svg>
                {{'LOGIN_OD0007' | translate}}
            </button>
        </div>
    </form>
</div>
